import { BaseComponent } from '../BaseComponent';
import { ComponentNames } from 'src/app/helper/componentNames';

export class AdjustableSeatComponent extends BaseComponent{
    constructor() {
        super();
        this.componentType = ComponentNames.adjustableSeatComponent;
    }
    groundSupport:boolean;
    footRest:boolean;
    tableBehind:boolean;
    tableForOwnSeat:boolean;
    socket:boolean;
    backrestAdjustable:boolean;
    armrestAvailable:boolean;
    length85:number;
    length60:number;
    lengthSeatSurface:number;
    heightLowerEdge:number;
}